import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'app-update-notification',
  standalone: true,
  imports: [NgbToastModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (updateAvailable()) {
      <ngb-toast
        [autohide]="false"
        class="position-fixed bottom-0 end-0 m-3"
        style="z-index: 1200; opacity: 1;"
        header="Update Available">

        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <p class="mb-2">A new version is available. Do you want to update?</p>
          </div>
          <div class="ms-3">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="reload()">
              Update
            </button>
          </div>
        </div>
      </ngb-toast>
    }
  `,
  styles: [`
    :host {
      position: relative;
      z-index: 1200;
    }

    ngb-toast {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      border: 1px solid rgba(0, 0, 0, 0.1);
      min-width: 350px;
      opacity: 1 !important;
      background-color: white;
    }

    .toast-header {
      background-color: var(--bs-primary);
      color: white;
      border-bottom: none;
    }

    .toast-body {
      padding: 1rem;
      background-color: white;
    }
  `],
})
export class UpdateNotificationComponent {
  private readonly versionService = inject(VersionService);

  readonly updateAvailable = this.versionService.updateAvailable;

  reload(): void {
    this.versionService.reloadApp();
  }
}
